import React, { useState } from 'react';
// import Slider from "react-slick";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'
import ProductFilter from "../components/ProductFilter";
import MakeAppoinment from '../components/make-appoinment';
import useGaspAnimations from '../components/useGsapAnimations'


const accordionData = [

{
id:1,
title:"Suction Accumulators",
content:"Suction accumulators protect compressors by preventing liquid refrigerant carryover in the suction line. Their robust design ensures stable system operation during load fluctuations and rapid defrost cycles. Built for industrial duty, they enhance compressor life and system reliability in ammonia and Freon-based systems."
},
{
id:2,
title:"Receivers",
content:"Refrigerant receivers provide essential storage capacity to manage system charge efficiently during operation and maintenance. Designed for high-pressure performance, they ensure smooth refrigerant flow and temperature stability across the refrigeration cycle. Each unit is engineered for durability, safety, and easy installation in industrial environments."
},
{
id:3,
title:"Chiller Barrels",
content:"Chiller barrels serve as the heart of liquid chilling systems, delivering efficient heat exchange for water and glycol applications. Precision-engineered tube designs provide maximum thermal performance and minimal pressure drop. Suitable for both low-temperature and comfort cooling systems, they offer dependable performance year after year."
},
{
id:4,
title:"Subcooler",
content:"Subcoolers improve system efficiency by lowering refrigerant temperature before expansion, increasing cooling capacity while reducing compressor load. Their compact, high-efficiency design enhances thermodynamic performance across the refrigeration cycle. Ideal for ammonia and other natural refrigerants, they contribute to lower energy consumption and optimized plant operation."
},
{
id:5,
title:"Oil Separators",
content:"Oil separators ensure reliable compressor lubrication by efficiently separating and returning oil from the discharge gas. This improves compressor efficiency and protects key components from excessive wear. Engineered for continuous-duty industrial installations, they support consistent performance and extended system life."
}

]

function Pressurevessels() {

     useGaspAnimations()
     
  const [openSections, setOpenSections] = useState({ 1: true });

  const toggleSection = (id) => {
    setOpenSections((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  
     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

     var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 2000,
       
      };



    
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
 
{/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Pressure Vessels</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li><a href="services.html">Services</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Pressure Vessels</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start service single area--> */}
<section id="service-single-area">
    <div className="container">
        <div className="row">
                  <ProductFilter/>
            <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 pull-right">
                <div className="service-single-content">
                    {/* <!--Start top content --> */}
                    <div className="row top-content">
                        <div className="col-md-5 col-sm-12 col-xs-12 flex-image-middle bdFadeUp">
                             {/* <Slider {...settings}>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                            </Slider> */}
                             <img src="assets/images/OurProducts/Pressure-Vessels.webp" alt="Awesome Image"/>
                        </div>
                        <div className="col-md-7 col-sm-12 col-xs-12">
                            <div className="textholder">
                                <div className="sec-title bdFadeUp">
                                    <h1><span>Pressure Vessels</span></h1>
                                </div>
                                <div className="text bdFadeUp">
                                    {/* <span>We Are professional. Reliable and Affortable</span> */}
                                    <p className="top">
                                        Pressure vessels in industrial refrigeration systems safely store and regulate refrigerants under high pressures and temperatures, ensuring system stability and efficiency. Designed and fabricated per ASME Section VIII Division 1, they incorporate features like post-weld heat treatment, corrosion allowances, full vacuum capability, and pressure testing at 1.25 times design pressure (typically 250-300 psig MAWP for ammonia systems). Compliance with IIAR-2, ANSI B9.1, and EN 13445 standards guarantees ASME stamping, rigorous inspection, and overpressure protection for unmatched safety and reliability.
                                    </p>
                                    {/* <p>Who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences, or one who avoids a annoying consequences resultant pleasure.</p> */}
                                  <div className="single-sidebar">
                                                <a href="assets/indusref-refpak-brochure.pdf" className='single-pdf'>
                                                    <div className="icon-holder download">
                                                        <span className="flaticon-pdf-file-format-symbol"></span>    
                                                    
                                                    </div>
                                                    <div className="title-holder">
                                                        <h5>Download Here!</h5>    
                                                    </div>
                                                </a>
                                    </div> 
                                </div>

                             
                            </div>
                        </div>
                    </div>
                    {/* <!--End top content --> */}
                    <div className="row">
                        <div className="col-md-12">
                            <div className="border"></div>
                        </div>
                    </div>
                    {/* <!--Start middle content--> */}
                    <div className="row middle-content">
                        <div className="col-md-7">
                            <div className="text-holder">
                                <div className="title bdFadeUp">
                                    <h2>Sub-categories</h2>
                                </div>
                                <div className="text bdFadeUp">
                                    {/* <p>Don't spend time and money on beautiful landscaping if you have not taken water and irrigation issues into account first. Installing a sprinkler system, leveling the ground.</p> */}
                                    <ul >
                                         {accordionData.map(({title}) => (
                                            <li><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i>{title}</li>
                                            ))} 
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div className="col-md-5 bdFadeUp">
                             <Slider {...settings}>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                                <img src="assets/images/about/about-us.jpg" alt="Awesome Image"/>
                            </Slider>
                        </div> */}
                    </div>
                    {/* <!--End middle content--> */}
                      {/* <!--Start bottom content--> */}
                              <div className="row bottom-content">
                                    <div className="col-md-12">
                                        <div className="title bdFadeUp">
                                                <h2>Sub-category Descriptions</h2>
                                            </div>
                                        <div className="accordion-box bdFadeUp">
                                            {accordionData.map(({ id, title, content }) => (
                                            <>
                                            {/* <!--Start single accordion box--> */}
                                            <div className="accordion accordion-block" key={id}>
                                                <div className={`accord-btn ${openSections[id] ? 'active' : ''}`} onClick={() => toggleSection(id)}><h4>{title}</h4></div>
                                                {openSections[id] && (
                                                <div className="accord-content collapsed">
                                                    <p>
                                                    {content}
                                                    </p>
                                                </div>
                                                )}
                                            </div>
                                            {/* <!--End single accordion box-->  */}
                                            </>
                                            ))}
                                    </div>
                                </div>
                                </div>
                    {/* <!--End bottom content--> */}
     
                </div>
            </div>
           
            
        </div>
    </div>    
</section>
{/* <!--End service single area--> */}
 {/* <!--Start Consultation form--> */}
                     <MakeAppoinment/>
                    {/* <!--End Consultation form--> */}
          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Pressurevessels;
